import React, { useEffect, useState } from "react";
import {
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";

import { Link, withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  TabContent,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
} from "reactstrap";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import light from "../../../assets/images/logo-light.png";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../../assets/images/users/avatar-8.jpg";

import smallImage2 from "../../../assets/images/small/img-2.jpg";
import smallImage3 from "../../../assets/images/small/img-3.jpg";
import smallImage4 from "../../../assets/images/small/img-4.jpg";
import smallImage5 from "../../../assets/images/small/img-5.jpg";
import smallImage6 from "../../../assets/images/small/img-6.jpg";
import smallImage7 from "../../../assets/images/small/img-7.jpg";
import smallImage9 from "../../../assets/images/small/img-9.jpg";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

const HistoriqueLivraisons = (props) => {
  SwiperCore.use([Autoplay]);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  function statutColor(statut) {
    let color;
    switch (statut) {
      case "En attente":
        color = "warning";
        break;
      case "Accepter":
        color = "info";
        break;
      case "Pret":
        color = "primary";
        break;
      case "Commencer":
        color = "success";
        break;
      case "Terminer":
        color = "success";
        break;
      case "Annuler":
        color = "danger";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }
  function convertDate(date) {
    return new Date(date);
  }

  const [activityTab, setActivityTab] = useState("3");

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

  const [livraisonList, setLivraisonList] = useState([]);
  const [optionFilter, setOptionFilter] = useState([]);
  const [optionFilterValue, setOptionFilterValue] = useState("");

  const [getStatus, setGetStatus] = useState(false);

  const fetchLivraisonList = async () => {
    try {
      const livraison_list = await axiosInstance.get(`/livraisondetail/`);

      setLivraisonList(
        livraison_list.data.data
          .filter(
            (livraison) =>
              livraison.statut !== "En attente" &&
              livraison.conducteur_id !== null
          )
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      );
      setGetStatus(true);

      // console.log(livraison_list);
      // console.log("livraison List: ", livraison_list.data.data);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    try {
      fetchLivraisonList();
    } catch (error) {
      console.error("Erreur de fetch livraison: ", error);
    }

    // finally {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 2000);
    // }
  }, []);

  const [loading, setLoading] = useState(true);
  const [livraisonsPeriod, setLivraisonsPeriod] = useState("");
  const [livraisonsPeriodList, setLivraisonsPeriodList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const onChangeLivraisonsPeriod = (period = "") => {
    // console.log("livraisonList: ", livraisonList);

    let datedebut, datefin;
    let listFiltered = [];

    switch (period) {
      case "aujourd'hui":
        setLivraisonsPeriod("aujourd'hui");
        datedebut = startOfToday();
        datefin = endOfToday();
        break;
      case "semaine":
        setLivraisonsPeriod("semaine");
        datedebut = startOfWeek(new Date(), { weekStartsOn: 1 }); // Assuming the week starts on Monday
        datefin = endOfWeek(new Date(), { weekStartsOn: 1 });
        break;
      case "mois":
        setLivraisonsPeriod("mois");
        datedebut = startOfMonth(new Date());
        datefin = endOfMonth(new Date());
        break;
      case "an":
        setLivraisonsPeriod("an");
        datedebut = startOfYear(new Date());
        datefin = endOfYear(new Date());
        break;
        
      default:
        setLivraisonsPeriod("");
        datedebut = null;
        datefin = null;
        break;
    }

    if (datedebut && datefin) {
      // Conversion des dates en objets Date
      const dateDebut = convertDate(datedebut);
      const dateFin = convertDate(datefin);

      listFiltered = livraisonList
        .filter(
          (livraison) =>
            convertDate(livraison.created_at) >= dateDebut &&
            convertDate(livraison.created_at) <= dateFin
        )
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } else {
      listFiltered = livraisonList;
    }

    setLivraisonsPeriodList(listFiltered);

    return listFiltered;
    // console.log("datedebut: ", datedebut);
    // console.log("datefin: ", datefin);
    // console.log("list Filtered: ", listFiltered);
  };

  useEffect(() => {
    // console.log("livraison Period List length: ", livraisonsPeriodList.length);
    onChangeLivraisonsPeriod();
  }, [livraisonList]);

  // Recherche
  useEffect(() => {
    let list = onChangeLivraisonsPeriod(livraisonsPeriod);
    // console.log("list: ", list);

    const listFiltered =
      list &&
      list
        .filter(
          (livraison) =>
            (livraison.statut &&
              livraison.statut
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.adresse_livraison &&
              livraison.adresse_livraison
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.adresse_enlevement &&
              livraison.adresse_enlevement
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.nom &&
              livraison.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (livraison.last_name_client &&
              livraison.last_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_client &&
              livraison.first_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_client &&
              livraison.first_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_conducteur &&
              livraison.first_name_conducteur
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))
        )
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    // setLivraisonsPeriodList(listFiltered);

    const listFilteredStatus =
      optionFilterValue !== ""
        ? listFiltered &&
          listFiltered.filter(
            (course) => course.statut && course.statut === optionFilterValue
          )
        : listFiltered;

    setLivraisonsPeriodList(listFilteredStatus);
  }, [optionFilterValue, searchTerm, livraisonList]);

  function getUniqueStatuses(courses) {
    const statuses = courses.map((course) => course.statut);
    return [...new Set(statuses)]; // Supprime les doublons
  }

  useEffect(() => {
    const status = getUniqueStatuses(livraisonList);
    // console.log("status: ", status);
    setOptionFilter(status);
  }, [livraisonList]);

  const mode = localStorage.getItem('layoutModeType')
  const [modeDark, setModeDark] = useState(false);
  // useEffect(() => {
   useEffect(() => {
      const mode = localStorage.getItem('layoutModeType');
      mode ==='dark' ? setModeDark(true) : setModeDark(false)
  }, [props.layoutModeType]); // OU mieux : à chaque fois que tu changes le mode global


  document.title = "Historique des livraisons | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={props.t("Livraisons")} pageTitle="Takci" />

          <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
              <img src={profileBg} alt="" className="profile-wid-img" />
            </div>
          </div>

          <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
            <Row className="g-4" style={{ justifyContent: "center" }}>
              <div className="col-auto">
                <div
                  className="avatar-lg"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={light} alt="user-img" width="100px" />
                </div>
              </div>
            </Row>
          </div>

          <div>
            <Row>
              <Col xxl={12}>
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardHeader className="align-items-center">
                        <div className="d-flex align-items-center">
                          <h4 className="card-title mb-0  me-2">
                            Livraisons {livraisonsPeriod}{" "}
                            {`(${livraisonsPeriodList.length})`}
                          </h4>

                          <div className="flex-shrink-0 ms-auto">
                            <div className="justify-content-end d-none d-md-flex gap-1">
                              <button
                                disabled={livraisonsPeriod === ""}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("tous");
                                }}
                              >
                                {props.t("Tous")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "aujourd'hui"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("aujourd'hui");
                                }}
                              >
                                {props.t("Today")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "semaine"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("semaine");
                                }}
                              >
                                {props.t("Week")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "mois"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("mois");
                                }}
                              >
                                {props.t("Month")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "an"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("an");
                                }}
                              >
                                {props.t("Year")}
                              </button>
                            </div>

                            <FormGroup className="d-block d-md-none">
                              <Input
                                id="exampleSelect"
                                name="select"
                                type="select"
                                onChange={(e) =>
                                  onChangeLivraisonsPeriod(e.target.value)
                                }
                              >
                                <option
                                  selected
                                  disabled={livraisonsPeriod === ""}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="tous"
                                >
                                  {props.t("Tous")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "aujourd'hui"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="aujourd'hui"
                                >
                                  {props.t("Today")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "semaine"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="semaine"
                                >
                                  {props.t("Week")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "mois"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="mois"
                                >
                                  {props.t("Month")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "an"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="an"
                                >
                                  {props.t("Year")}
                                </option>
                              </Input>
                            </FormGroup>
                          </div>
                        </div>
                        <div className="flex-shrink-0 ms-auto mt-3">
                          <div className="justify-content-end gap-1">
                            <Input
                              readOnly={livraisonsPeriodList.length < 0}
                              type="text"
                              placeholder="Rechercher..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        {!loading ? (
                          livraisonsPeriodList &&
                          livraisonsPeriodList.length > 0 ? (
                            <div>
                              <Row className="mb-3 g-3 justify-content-end">
                                <Col sm="6" className="mb-3">
                                  <select
                                    id="custom-select"
                                    className="form-select"
                                    value={optionFilterValue}
                                    onChange={(e) => {
                                      setOptionFilterValue(
                                        e.target.value || ""
                                      );
                                    }}
                                  >
                                    <option value="">Tous</option>
                                    {optionFilter.map((option, key) => (
                                      <>
                                        <option key={key} value={option}>
                                          {option}
                                        </option>
                                      </>
                                    ))}
                                  </select>
                                </Col>
                              </Row>

                              <div className="profile-timeline">
                                <div
                                  className="accordion accordion-flush"
                                  // id="headingOne"
                                >
                                  {livraisonsPeriodList.map(
                                    (livraison, key) => {
                                      return (
                                        <div
                                          className="accordion-item border-0"
                                          key={key}
                                          id={`${livraison.id}`}
                                        >
                                          <div
                                            className="accordion-header"
                                            id={`heading${key}`}
                                          >
                                            <Link
                                              to="#"
                                              className="accordion-button p-2 shadow-none"
                                              id="collapseTwo"
                                            >
                                              <div className="d-flex">
                                                <div
                                                  className="flex-shrink-0"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <i
                                                    className={`bx bx-${
                                                      livraison.type_engin_id ===
                                                      1
                                                        ? "car"
                                                        : livraison.type_engin_id ===
                                                          1
                                                        ? ""
                                                        : "cycling"
                                                    } avatar-xs rounded-circle`}
                                                    style={{
                                                      border:
                                                        "1px solid #002437",
                                                      background: `${modeDark ? '#002437' : 'white'}`,
                                                      fontSize: "2rem",
                                                    }}
                                                  />
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                  <Row className="w-100 fs-14 mb-1 d-flex justify-content-between">
                                                    <Col xxl={9}>
                                                      {formatDate(
                                                        livraison.created_at
                                                      )}
                                                    </Col>

                                                    <Col
                                                      xxl={3}
                                                      className={`justify-content-end`}
                                                    >
                                                      <span
                                                        className={`badge bg-soft-${statutColor(
                                                          livraison.statut
                                                        )} text-${statutColor(
                                                          livraison.statut
                                                        )} align-middle`}
                                                      >
                                                        {livraison.statut}
                                                      </span>
                                                    </Col>
                                                  </Row>
                                                  <small className="text-muted">
                                                    {
                                                      livraison.adresse_enlevement
                                                    }
                                                    {" -- "}
                                                    {
                                                      livraison.adresse_livraison
                                                    }
                                                  </small>
                                                </div>
                                              </div>
                                            </Link>
                                          </div>
                                          <UncontrolledCollapse
                                            className="accordion-collapse"
                                            toggler={`#heading${key}`}
                                            defaultOpen={key === 0}
                                          >
                                            <div className="accordion-body ms-2 ps-5">
                                              <ul className="list-unstyled text-muted vstack gap-3">
                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="bx bx-trip fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Départ: </b>
                                                      {
                                                        livraison.adresse_enlevement
                                                      }
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Code livraison: </b>
                                                      {livraison.code_livraison ? (
                                                        livraison.code_livraison
                                                      ) : (
                                                        <span
                                                          className={` text-danger`}
                                                        >
                                                          Pas de code
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="bx bx-trip fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Destination: </b>
                                                      {
                                                        livraison.adresse_livraison
                                                      }
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Code Enlevement: </b>
                                                      {
                                                        livraison.code_enlevement
                                                      }
                                                      {livraison.code_enlevement ? (
                                                        livraison.code_enlevement
                                                      ) : (
                                                        <span
                                                          className={` text-danger`}
                                                        >
                                                          Pas de code
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                </li>

                                                {/* <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Type d'engin: </b>
                                                      {
                                                        livraison.designation_type_engin
                                                      }
                                                    </div>
                                                  </div>
                                                </li> */}

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Distance: </b>
                                                      {livraison.distance_estimee ||
                                                        0}
                                                      {" Km"}
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Type de colis: </b>
                                                      {livraison.type_colis}
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Coût: </b>
                                                      {livraison.cout_estimee}
                                                      {" XOF"}
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Mode de paiement: </b>
                                                      {livraison.mode_payement}
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Client: </b>
                                                      <Link
                                                        to={`client/${livraison.client_id}`}
                                                      >
                                                        {
                                                          livraison.first_name_client
                                                        }{" "}
                                                        {
                                                          livraison.last_name_client
                                                        }
                                                      </Link>
                                                    </div>
                                                  </div>
                                                </li>

                                                <li>
                                                  <div className="d-flex">
                                                    <div className="flex-shrink-0 text-secondary me-1">
                                                      <i className="ri-subtract-line fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                      <b>Conducteur: </b>
                                                      <Link
                                                        to={`chauffeur/${livraison.conducteur_id}`}
                                                      >
                                                        {
                                                          livraison.first_name_conducteur
                                                        }{" "}
                                                        {
                                                          livraison.last_name_conducteur
                                                        }
                                                      </Link>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </div>
                                          </UncontrolledCollapse>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center my-3">
                              <h2>Pas de livraison</h2>
                            </div>
                          )
                        ) : (
                          <div className="text-center my-3">
                            <Loader style={{ color: "#014c94" }} />
                            <h2>Chargement...</h2>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

HistoriqueLivraisons.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(HistoriqueLivraisons));
